import { envKeys, smokeballPoolKeys } from "@smart/bridge-env-types-basic";
import { buildApiGatewayDef } from "@smart/itops-constructs-basic";
import { buildNamespace } from "@smart/itops-types-basic";
import { keysOf } from "@smart/itops-utils-basic";

import { system } from "./base";
import { cdn } from "./cloudfront";

const lambdaDefs = {
  check: {
    pkg: "@smart/auth-check-lambda",
    deployable: "check",
    method: "GET",
    authenticated: false,
    env: [],
  },
  clear: {
    pkg: "@smart/auth-clear-lambda",
    deployable: "clear",
    method: "GET",
    authenticated: false,
    env: [],
  },
  env: {
    pkg: "@smart/auth-env-lambda",
    deployable: "env",
    method: "GET",
    authenticated: false,
    env: [...smokeballPoolKeys],
  },
  recall: {
    pkg: "@smart/auth-recall-lambda",
    deployable: "recall",
    method: "GET",
    authenticated: false,
    env: [],
  },
  stash: {
    pkg: "@smart/auth-stash-lambda",
    deployable: "stash",
    method: "POST",
    authenticated: false,
    env: [],
  },
} as const;

export const apiGateway = buildApiGatewayDef({
  envKeys,
  cdn,
  namespace: buildNamespace({ system, entity: "signin" }),
  prefix: "api",
  authorized: false,
  authorizer: undefined,
  lambdaKeys: keysOf(lambdaDefs),
  lambdas: lambdaDefs,
  port: 9121,
});
